// https://arbiscan.io/address/0xCbFB78a3Eeaa611b826E37c80E4126c8787D29f0
export const CROSS_CHAIN_CONTROLLER = '0xCbFB78a3Eeaa611b826E37c80E4126c8787D29f0';

// IPayloadsControllerCore https://arbiscan.io/address/0x89644CA1bB8064760312AE4F03ea41b05dA3637C
export const PAYLOADS_CONTROLLER = '0x89644CA1bB8064760312AE4F03ea41b05dA3637C';

// https://arbiscan.io/address/0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A
export const PC_DATA_HELPER = '0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A';

// https://arbiscan.io/address/0x4922093c476CfbCF903C7C4082d2D64bAE8A37cE
export const GRANULAR_GUARDIAN = '0x4922093c476CfbCF903C7C4082d2D64bAE8A37cE';

// https://arbiscan.io/address/0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b
export const GOVERNANCE_GUARDIAN = '0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b';

// https://arbiscan.io/address/0xFF1137243698CaA18EE364Cc966CF0e02A4e6327
export const EXECUTOR_LVL_1 = '0xFF1137243698CaA18EE364Cc966CF0e02A4e6327';

export const CHAIN_ID = 42161;
